import { CellInfo } from 'react-table-6';
import { fn2nZ } from '../../core/formatter/formatNumber';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export class ZusatztoolsEinzelmassnahmen extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private columns: any[] = [
        { id: 'endenergiebedarf_vor_massnahme', name: 'Endenergiebedarf vor Maßnahme [MWh/a]' },
        { id: 'endenergiebedarf_nach_massnahme', name: 'Endenergiebedarf nach Maßnahme [MWh/a]' },
        // { id: 'primaerenergiebedarf_vor_massnahme', name: 'Primärnergiebedarf vor Maßnahme [MWh/a]' },
        // { id: 'primaerenergiebedarf_nach_massnahme', name: 'Primärnergiebedarf nach Maßnahme [MWh/a]' },
        { id: 'endenergieeinsparung', name: 'Endenergieeinsparung [MWh/a]' },
        // { id: 'primaerenergieeinsparung', name: 'Primärnergieeinsparung [MWh/a]' },
        { id: 'treibhausgaseinsparung', name: 'Treibhausgaseinsparung [t CO₂-äq./a]' }
    ];

    getColumnValue(name: string, data: any): number {
        const faktoren: any = { 7: 0.208, 11: 0.606, 12: 0.208, 13: 0.250, 14: 0.267, 15: 0.027, 16: 0.027, 17: 0.027, 18: 0.346 };
        const primaerfaktoren: any = { 7: 0.7, 11: 1.8, 12: 1.3, 13: 1.1, 14: 1.1, 15: 0.2, 16: 0.2, 17: 0.2, 18: 1.1 };
        const energietraeger_nachher = data.energietraeger_tid_nachher_orig || null;
        const energietraeger_nachher_faktor = faktoren[energietraeger_nachher] || 1;
        const energietraeger_nachher_primaerfaktor = primaerfaktoren[energietraeger_nachher] || 1;
        const energietraeger_vorher = data.energietraeger_tid_vorher_orig || null;
        const energietraeger_vorher_faktor = faktoren[energietraeger_vorher] || 1;
        const energietraeger_vorher_primaerfaktor = primaerfaktoren[energietraeger_vorher] || 1;
        const verbrauch_nachher: number = +data.verbrauch_nachher || null;
        const verbrauch_vorher: number = +data.verbrauch_vorher || null;
        let endenergiebedarf_vor_massnahme: number = null;
        let endenergiebedarf_nach_massnahme: number = null;
        let primaerenergiebedarf_vor_massnahme: number = null;
        let primaerenergiebedarf_nach_massnahme: number = null;
        let endenergieeinsparung: number = +data.einsparungen || null;
        let primaerenergieeinsparung: number = null;
        let treibhausgaseinsparung: number = null;

        // Einheit: 1 => kWh, 2 => MWh
        if (energietraeger_vorher && energietraeger_nachher) {
            if (verbrauch_vorher) {
                endenergiebedarf_vor_massnahme = verbrauch_vorher / (data.einheit_verbrauch_vorher_orig === 1 ? 1000 : 1);
                primaerenergiebedarf_vor_massnahme = endenergiebedarf_vor_massnahme * energietraeger_vorher_primaerfaktor;
            }
            if (verbrauch_nachher) {
                endenergiebedarf_nach_massnahme = verbrauch_nachher / (data.einheit_verbrauch_nachher_orig === 1 ? 1000 : 1);
                primaerenergiebedarf_nach_massnahme = endenergiebedarf_nach_massnahme * energietraeger_nachher_primaerfaktor;
                primaerenergieeinsparung = primaerenergiebedarf_vor_massnahme - primaerenergiebedarf_nach_massnahme;
                treibhausgaseinsparung = (endenergiebedarf_vor_massnahme - endenergiebedarf_nach_massnahme) * energietraeger_nachher_faktor;
            }
        }

        switch (name) {
            case 'endenergiebedarf_vor_massnahme':
                return endenergiebedarf_vor_massnahme;
            case 'endenergiebedarf_nach_massnahme':
                return endenergiebedarf_nach_massnahme;
            case 'primaerenergiebedarf_vor_massnahme':
                return primaerenergiebedarf_vor_massnahme;
            case 'primaerenergiebedarf_nach_massnahme':
                return primaerenergiebedarf_nach_massnahme;
            case 'endenergieeinsparung':
                return endenergieeinsparung;
            case 'primaerenergieeinsparung':
                return primaerenergieeinsparung;
            case 'treibhausgaseinsparung':
                return treibhausgaseinsparung;
            default:
                return null;
        }
    }

    getCustomColumns(): any[] {
        return this.columns.map((column: any) => {
            const id: string = column.id || null;
            const name: string = column.name || null;
            return {
                accessor: id,
                Header: name,
                HeaderText: name,
                id,
                filterable: false,
                Cell: (row: CellInfo) => fn2nZ(this.getColumnValue(id, row.original || {}))
            };
        });
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_EINZELMASSNAHMEN}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                addLabel='Einzelmaßnahme erfassen'
                customColumns={this.getCustomColumns()}
                tableOrder={[
                    'einzelmassnahmen_art_tid', 'einzelmassnahmen_massnahme_tid', 'name', 'zustand_vorher',
                    'einzelmassnahmen_berechnung_tid', 'einzelmassnahmen_baseline_tid', 'datum_inbetriebsetzung',
                    'energietraeger_tid_vorher', 'verbrauch_vorher', 'einheit_verbrauch_vorher',
                    'energietraeger_tid_nachher', 'verbrauch_nachher', 'einheit_verbrauch_nachher',
                    'umsetzendes_unternehmen', 'investition', 'einzelmassnahmen_foerdermittel_tid', 'endenergiebedarf_vor_massnahme',
                    'endenergiebedarf_nach_massnahme', /*'primaerenergiebedarf_vor_massnahme', 'primaerenergiebedarf_nach_massnahme',*/
                    'endenergieeinsparung', /*'primaerenergieeinsparung',*/ 'treibhausgaseinsparung'
                ]}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_EINZELMASSNAHMEN)}
                disableFieldSelectDefaultOptions={{
                    einheit_verbrauch_vorher: true,
                    einheit_verbrauch_nachher: true,
                }}
                validateField={(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void): string => {
                    const values = data.values;
                    if (key === 'verbrauch_vorher' || key === 'verbrauch_nachher' || key === 'einheit_verbrauch_vorher' || key === 'einheit_verbrauch_nachher') {
                        if ((values.verbrauch_vorher > 0 || values.verbrauch_nachher > 0) && values.einheit_verbrauch_vorher && values.einheit_verbrauch_nachher) {
                            // Einheit: 1 => kWh, 2 => MWh
                            const einsparungen = values.verbrauch_vorher / (values.einheit_verbrauch_vorher === 1 ? 1000 : 1)
                                - values.verbrauch_nachher / (values.einheit_verbrauch_nachher === 1 ? 1000 : 1);
                            // console.log(einsparungen);
                            onValueChange('einsparungen', +einsparungen.toFixed(2), false);
                        }
                    }
                    return null;
                }}
            />
        );
    }
}
